import { useEffect } from "react"
import CloseButton from "../../components/CloseButton/CloseButton"
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton"
import { useAppState } from "../../context/appStateContext"
import { useBlackFriday } from "../../context/blackFridayContext"
import { usePricingData } from "../../hooks/usePricingData"
import useStrings from "../../localization/useStrings"
import native from "../../native/native"
import Svg from "../../utils/svg"
import styles from "./BlackFridayNoFeaturesPaywall.module.scss"

const Footer = () => {
  const strings = useStrings()
  const { actions } = useBlackFriday()
  const { discountedPrice, yearlyPerMonthPrice } = usePricingData()

  return (
    <div className={styles.footer}>
      <div className={styles.planContainer}>
        <div className={styles.planHeader}>{strings.lowestPrice}</div>
        <div className={styles.planContent}>
          <div className={styles.planLeft}>
            <div className={styles.planName}>{strings.yearlyPlan}</div>
            <div className={styles.planDetails}>
              {strings.premiumToUltimateBlackFriday.monthPrefix}
              {discountedPrice}
            </div>
          </div>
          <div className={styles.planRight}>{yearlyPerMonthPrice} / mo</div>
        </div>
      </div>

      <PrimaryButton
        className={styles.ctaButton}
        onClick={() => actions.purchaseYearly()}
      >
        {strings.blackFridayNoFeatures.claimOffer}
      </PrimaryButton>
    </div>
  )
}

const Title = () => {
  const strings = useStrings()

  return (
    <div className={styles.titleContainer}>
      <label className={`${styles.title} ${styles.titleOffset}`}>
        {strings.blackFridayNoFeatures.title}
      </label>
      <label className={styles.title}>
        {strings.blackFridayNoFeatures.title}
      </label>
    </div>
  )
}

const DiscountContainer = () => {
  const { savePercent } = usePricingData()
  const strings = useStrings()

  return (
    <div className={styles.discountSection}>
      <Svg.StartsLeft className={styles.starsLeft} />
      <div className={styles.discountBadge}>
        <div className={styles.discountText}>
          {Math.round(savePercent)}% {strings.off}
        </div>
      </div>
      <Svg.StartsRight className={styles.starsRight} />
    </div>
  )
}

const BulletPoints = () => {
  const strings = useStrings()

  const bullets = [
    { emoji: "☕️", text: strings.blackFridayNoFeatures.lessThanCoffee },
    { emoji: "⚠️", text: strings.blackFridayNoFeatures.dontWait },
    { emoji: "🤷🏻", text: strings.blackFridayNoFeatures.whatWaiting },
  ]

  return (
    <div className={styles.bulletPoints}>
      {bullets.map((bullet, index) => (
        <div key={index} className={styles.bulletPoint}>
          <span className={styles.emoji}>{bullet.emoji}</span>
          <span className={styles.bulletText}>{bullet.text}</span>
        </div>
      ))}
    </div>
  )
}

const BlackFridayNoFeaturesPaywall = () => {
  const { totalPrice, yearlyPerMonthPrice } = usePricingData()

  const appActions = useAppState().actions

  useEffect(() => {
    appActions.setHeaderInsetColor("black")
    appActions.setFooterInsetColor("black")
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <CloseButton
          className={styles.closeButton}
          onClick={() => native.postNativeEvent("close")}
          color="white"
        />
        <Title />
        <DiscountContainer />
        <div className={styles.priceSection}>
          <div className={styles.originalPrice}>{totalPrice}</div>
          <div className={styles.discountedPrice}>
            {yearlyPerMonthPrice} / mo
          </div>
        </div>
        <BulletPoints />
      </div>
      <Footer />
    </div>
  )
}

export default BlackFridayNoFeaturesPaywall
